import React from 'react';
import type { useApplicationDetail } from '../../hooks/useApplicationDetail';

interface Props { h: ReturnType<typeof useApplicationDetail>; }

export const CoursesSection: React.FC<Props> = ({ h }) => {
  const { editedCourses, agreeToFoundationCourses } = h;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold flex items-center">
          Kursy i Szkolenia
          <span className="ml-3 text-sm bg-blue-100 text-blue-700 px-3 py-1 rounded-full">Zarządzanie</span>
        </h2>
        <button onClick={h.handleAddCourse} className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 flex items-center text-sm">
          + Dodaj kurs
        </button>
      </div>
      <div className="space-y-4">
        {editedCourses.length === 0 ? (
          <p className="text-gray-500 italic">Brak wpisów. Kliknij "Dodaj kurs" aby dodać ukończone szkolenia.</p>
        ) : (
          editedCourses.map((course, index) => (
            <div key={index} className="border-2 border-gray-200 rounded-lg p-4 bg-gray-50">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-semibold text-gray-700">Kurs #{index + 1}</h3>
                <button onClick={() => h.handleRemoveCourse(index)} className="text-red-600 hover:text-red-800 font-medium text-sm">Usuń</button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nazwa kursu</label>
                  <input type="text" value={course.course_name || ''} onChange={(e) => h.handleCourseChange(index, 'course_name', e.target.value)} className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500" placeholder="np. Kurs księgowości" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Rok ukończenia</label>
                  <input type="number" value={course.completion_year || ''} onChange={(e) => h.handleCourseChange(index, 'completion_year', parseInt(e.target.value))} className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500" min="1950" max={new Date().getFullYear()} placeholder="YYYY" />
                </div>
                <div className="flex items-center">
                  <label className="flex items-center cursor-pointer">
                    <input type="checkbox" checked={course.has_certificate || false} onChange={(e) => h.handleCourseChange(index, 'has_certificate', e.target.checked)} className="mr-2" />
                    <span className="text-sm font-medium text-gray-700">Posiada certyfikat</span>
                  </label>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="mt-6 p-4 bg-gradient-to-r from-cyan-50 to-blue-50 border-2 border-cyan-200 rounded-lg">
        <label className="flex items-start cursor-pointer">
          <input type="checkbox" checked={agreeToFoundationCourses} onChange={(e) => h.setAgreeToFoundationCourses(e.target.checked)} className="mr-3 mt-1" />
          <div>
            <span className="text-sm font-semibold text-gray-800 block mb-1">Zgadzam się na odbycie dodatkowych kursów w Fundacji NH</span>
            <span className="text-xs text-gray-600">Kandydat wyraża zgodę na uczestnictwo w bezpłatnych kursach oferowanych przez Fundację NH w celu podniesienia kwalifikacji zawodowych.</span>
          </div>
        </label>
      </div>
    </div>
  );
};

export const CoursesViewSection: React.FC<Props> = ({ h }) => {
  const { application } = h;
  const courses = application?.courses || [];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold flex items-center">
          Kursy i Szkolenia
          <span className="ml-3 text-sm bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full">{courses.length}</span>
        </h2>
      </div>
      {courses.length === 0 ? (
        <p className="text-gray-400 italic text-sm">Brak wpisów o kursach. Klient może je dodać przez portal lub operator w trybie edycji.</p>
      ) : (
        <div className="space-y-3">
          {courses.map((course: any, idx: number) => (
            <div key={idx} className="border-l-4 border-purple-500 pl-4 py-2 bg-purple-50/30 rounded-r-lg">
              <div className="flex items-center justify-between">
                <p className="font-semibold text-gray-900">{course.course_name || 'Bez nazwy'}</p>
                {course.has_certificate && (
                  <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Certyfikat</span>
                )}
              </div>
              {course.completion_year && (
                <span className="text-xs text-gray-500">Rok: {course.completion_year}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
